import Datepicker from 'vuejs-datepicker'
import { cloneDeep } from 'lodash'

// Require at the component mixin is includes:
// data:
// - items
export default {
  components: { Datepicker },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      show: true
    }
  },
  computed: {
    getUsersWithTrashedForSelect () {
      const usersNotActive = []
      for (const i in this.items) {
        if (!this.items[i].user) {
          continue
        }
        if (!this._prodDepUsersWithTrashed.some(user => user.id === this.items[i].user.id)) {
          const newUserItem = this.items[i].user
          newUserItem.disabled = true
          usersNotActive.push(newUserItem)
        }
      }
      if (usersNotActive.length > 0) {
        return [...this._prodDepUsersWithTrashed, ...usersNotActive]
      } else {
        return this._prodDepUsersWithTrashed
      }
    }
  },
  mounted () {
    if (this.$store.getters.getAllUsers.length === 0) {
      this.fetchAllUsers()
    }
    this.setInitialParams()
  },
  watch: {
    'value': {
      deep: true,
      handler () {
        this.setInitialParams()
      }
    }
  },
  methods: {
    convertDataToString (value) {
      if (value) return value.toString()
    },
    setInitialParams () {
      this.items = (this.value && this.value.length > 0) ? this.value : [cloneDeep(this.defaultItem)]
      this.triggerInputEmit()
    },
    async fetchAllUsers () {
      return this.$api.users.getAllUsers()
    },
    addItem () {
      this.show = true
      this.items.push(cloneDeep(this.defaultItem))
      this.triggerInputEmit()
    },
    removeItem (data) {
      const removedIndex = data.index
      this.items = this.items.filter((item, index) => index !== removedIndex)
      this.triggerInputEmit()
      this.$emit('dataRemoved', { removedIndex })
    },
    triggerInputEmit () {
      this.$emit('input', this.items)
    },
    dataTouched (index, attrName, attrValue) {
      this.$emit('dataTouched', { index, attrName, attrValue })
    },
    hoursTooltip (item) {
      let tooltipText = ''
      if (item.calculateHours && (item.hours_amount_logged || item.hours_amount_time_offs || item.hours_amount_planned)) {
        tooltipText = 'Auto fill: '
        tooltipText += item.hours_amount_logged ? item.hours_amount_logged + ' hours from log times ' : ''
        tooltipText += item.hours_amount_time_offs ? item.hours_amount_time_offs + ' hours from time offs ' : ''
        tooltipText += item.hours_amount_planned ? item.hours_amount_planned + ' planned working hours' : ''
      }
      return tooltipText
    },
    togglePanel (event) {
      event.preventDefault()
      this.show = !this.show
    }
  }
}
